import type { FeatureManifest } from '@/platform/navigation/featureManifest'
export const achievementsManifest: FeatureManifest = { id: 'achievements', path: 'achievements/*', navPath: '/achievements', label: 'Thành tựu', description: 'Quản lý nhóm và danh hiệu', load: () => import('./entry') }
